import React from "react";
import { cn } from "../ui";

interface StatusCardProps {
  icon?: React.ReactNode;
  tone?: "primary" | "danger" | "warning";
  title?: React.ReactNode;
  /** Botões empilhados embaixo, com a largura do card. */
  actions?: React.ReactNode;
  /** "start" para formulários (rótulos alinhados à esquerda). */
  align?: "center" | "start";
  children?: React.ReactNode;
}

const TONES = {
  primary: "bg-primary-soft text-primary",
  danger: "bg-danger-soft text-danger",
  warning: "bg-warning-soft text-warning",
};

/** Tela avulsa fora do app (erro, convite, checkout, onboarding): um card centralizado no fundo azul-claro. */
export const StatusCard: React.FC<StatusCardProps> = ({ icon, tone = "primary", title, actions, align = "center", children }) => (
  <main className="flex min-h-screen items-center justify-center bg-gradient-to-b from-primary-tint to-surface to-60% px-4 py-8">
    <div
      className={cn(
        "flex w-full max-w-md animate-rise flex-col gap-4 rounded-card border border-line bg-surface p-7 shadow-card",
        align === "center" ? "items-center text-center" : "items-stretch"
      )}
    >
      {icon && (
        <span className={cn("grid h-16 w-16 place-items-center self-center rounded-full", TONES[tone])} aria-hidden>
          {icon}
        </span>
      )}
      {title && <h1 className={cn("text-title-sm font-semibold text-fg", align === "start" && "text-center")}>{title}</h1>}
      {children && <div className="flex w-full flex-col gap-3 text-body text-fg-muted">{children}</div>}
      {actions && <div className="flex w-full flex-col gap-2">{actions}</div>}
    </div>
  </main>
);
